import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import CookieDisclaimer from "../components/CookieDisclaimer";
import SEO from "../components/SEO";
import "../styles.css";

export default function Streamers() {
  const [visibleCount, setVisibleCount] = useState(9);

  // Static streamer data - replace with your actual streamed games
  const streamers = [
    {
      id: 1,
      name: "zemaxi",
      twitchName: "zemaxi",
      profilePic: "https://static-cdn.jtvnw.net/jtv_user_pictures/default-profile-300x300.png", // Placeholder - replace with actual Twitch profile pic
      bannerImage: "/images/streamer-banner-zemaxi.png", // Placeholder for banner with game characters
      favoriteGames: [
        {
          name: "Assassin's Creed Shadows",
          characterImage: "/images/ac-shadows-yasuke.png",
          description: "Love the stealth mechanics and Japanese setting"
        },
        {
          name: "Persona 3 Reload",
          characterImage: "/images/persona3-sephiroth.png",
          description: "Amazing story and social links system"
        },
        {
          name: "Spyro Reignited Trilogy",
          characterImage: "/images/spyro-spyro.png",
          description: "Nostalgic platforming adventure"
        }
      ],
      description: "Your favorite streamer playing RPGs, action games, and retro classics!"
    },
    {
      id: 2,
      name: "Rod_Legion",
      twitchName: "rod_legion",
      profilePic: "https://static-cdn.jtvnw.net/jtv_user_pictures/default-profile-300x300.png", // Placeholder - replace with actual Twitch profile pic
      bannerImage: "/images/streamer-banner-rod.png", // Placeholder for banner with game characters
      favoriteGames: [
        {
          name: "Call of Duty",
          characterImage: "/images/cod-ghost.png",
          description: "Competitive multiplayer action"
        },
        {
          name: "Fortnite",
          characterImage: "/images/fortnite-character.png",
          description: "Battle royale excitement"
        },
        {
          name: "Apex Legends",
          characterImage: "/images/apex-wattson.png",
          description: "Team-based shooter gameplay"
        }
      ],
      description: "Competitive gaming and battle royale streams!"
    }
  ];

  const paginatedStreamers = streamers.slice(0, visibleCount);

  function handleLoadMore() {
    setVisibleCount(v => v + 9);
  }

  return (
    <>
      <SEO
        title="Featured Streamers"
        description="Discover awesome Twitch streamers recommended by ZeMaxi! Find new content creators to watch and support in the gaming community."
        keywords="Twitch streamers, gaming streamers, content creators, Twitch recommendations, gaming community"
        url="https://zemaxi.com/streamers"
      />
      <Navbar />
      <CookieDisclaimer />
      <main>
        <section className="videos-hero">
          <div className="container">
            <h1>Twitch <span className="highlight">Streamers</span></h1>
            <p>Check out other awesome streamers and their favorite games!</p>
          </div>
        </section>
        <section className="videos-section">
          <div className="container videos-container">
            <div className="videos-grid">
              {paginatedStreamers.map(streamer => (
                <div className="video-item streamer-card" key={streamer.id}>
                  <div className="streamer-banner" style={{backgroundImage: `url(${streamer.bannerImage})`}}>
                    <div className="streamer-overlay">
                      <div className="streamer-header">
                        <img
                          src={streamer.profilePic}
                          alt={`${streamer.name} profile`}
                          className="streamer-profile-pic"
                        />
                        <h3>{streamer.name}</h3>
                        <a
                          href={`https://twitch.tv/${streamer.twitchName}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="twitch-link"
                        >
                          Watch on Twitch
                        </a>
                      </div>
                      <div className="streamer-games">
                        {streamer.favoriteGames.map((game, index) => (
                          <div key={index} className="game-character">
                            <img
                              src={game.characterImage}
                              alt={`${game.name} character`}
                              className="character-image"
                            />
                            <div className="game-info">
                              <h4>{game.name}</h4>
                              <p>{game.description}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="streamer-info">
                    <p>{streamer.description}</p>
                  </div>
                </div>
              ))}
            </div>
            {paginatedStreamers.length < streamers.length && (
              <div className="load-more-container">
                <button className="btn btn-primary" onClick={handleLoadMore}>Load More</button>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
